<template>
    <!--
      作者：luoyiming
      时间：2019-10-25
      描述：服务信息
  -->
    <div class="pb50">
        <div class="product-content" >
            <!--基本信息-->
            <div class="common-form">评价</div>
            <div class="table-wrap" >
                <el-row>
                    <el-col>
                        <div class="pb16">
                            <span class="gray9">吃力程度：</span>
                            {{ detail.waiterToUser.new_force  }}
                        </div>
                    </el-col>
                    <el-col>
                        <div class="pb16">
                            <span class="gray9">地址：</span>
                            <span style="color:rgb(255, 0, 221)">
                                {{ detail.waiterToUser.new_address  }}
                            </span>
                        </div>
                    </el-col>
                    <el-col>
                        <div class="pb16">
                            <span class="gray9">危险程度：</span>
                            <span style="color:rgb(46, 6, 226)">
                                {{ detail.waiterToUser.new_danger  }}
                            </span>
                        </div>
                    </el-col>
                    <el-col>
                        <div class="pb16">
                            <span class="gray9">行为举止：</span>
                            <span style="color:red">
                                {{ detail.waiterToUser.new_behavior  }}
                            </span>
                        </div>
                    </el-col>
                    <el-col>
                        <div class="pb16">
                            <span class="gray9">内容：</span>
                            <span style="color:rgb(2, 224, 39)">
                                {{ detail.waiterToUser.technician_content  }}
                            </span>
                        </div>
                    </el-col>
                </el-row>

            </div>

        </div>

    </div>
</template>

<script>
export default {
   inject: ["detail"],
    data() {
        return {
            // myaddress:{
            //     new_force:'',
            //     new_address:'',
            //     new_danger:'',
            //     new_behavior:'',
            //     technician_content:''
            // },
            loading:false
        };
    },
    created() {
       
        // if(this.detail.waiterToUser){
        //     if(this.detail.waiterToUser.list){
        //         console.log(123)
        //         console.log(this.detail.waiterToUser.list)
        //         if(this.detail.waiterToUser.list[0]){
        //         this.myaddress = this.detail.waiterToUser.list[0]
        //             this.loading = true
        //         }

        //     }
        // }
     },
    methods: {}
};
</script>
<style lang="scss" scoped>
.img {
    width: 60px;
    height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/order/part/appraise.vue